import { fetcher } from "../../utils/fetcher.js";

export const getMyDay = () => fetcher.get("/api/search/my-day");
